import React from 'react';
import {Grid, Header, Icon} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {SelectVendorModal} from './SelectVendorModal';
import produce from 'immer';

const ErrorIndicator = ({errorType, children}) => {
  const color = errorType === 'warning' ? 'yellow' : 'red';
  return (
    <React.Fragment>
      <Icon name="exclamation circle" size="large" color={color} /> {children}
    </React.Fragment>
  );
};

export class VendorDetails extends React.Component {
  state = {
    showVendorList: false,
    selectedVendorId: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {vendors: propsVendors, linkedVendorId} = nextProps;
    const vendors =
      _.size(propsVendors) > 0 && propsVendors.vendorMatched !== false
        ? produce(propsVendors, (draft) => {
            _.unset(draft, 'loading');
          })
        : [];

    const numVendorsFound = _.size(vendors);
    prevState.vendors = vendors;
    prevState.numVendorsFound = numVendorsFound;
    if (numVendorsFound == 1) {
      prevState.selectedVendorId = _.get(vendors, '0.vendorId');
    } else if (linkedVendorId && prevState.selectedVendorId === null) {
      prevState.selectedVendorId = linkedVendorId;
    }
    return prevState;
  }

  toggleVendorListModal = (e) => {
    e && e.preventDefault();
    this.setState({showVendorList: !this.state.showVendorList});
  };

  selectVendor = (vendorId) => {
    this.setState({
      showVendorList: false,
      selectedVendorId: vendorId,
    });
    this.props.selectVendor(vendorId);
  };

  selectVendorLink() {
    return (
      <React.Fragment>
        <Icon name="exclamation circle" size="large" color="yellow" />
        <a href="#" onClick={this.toggleVendorListModal}>
          Select vendor
        </a>
      </React.Fragment>
    );
  }

  render() {
    const {selectedVendorId, numVendorsFound, vendors} = this.state;
    const {organization, readOnly, toggles} = this.props;

    /* 
    this is like this because some  templates come to this directly and therefore don't have the toggle in props, but they have it in context
    if your vendor details is not showing properly add
    "toggles":"context.toggles.toggles"
    to the dependencies in the template 
    */
    const dunsToUEIToggle = this.props.hasOwnProperty('dunsToUEIToggle')
      ? this.props.dunsToUEIToggle
      : _.includes(toggles, 'dunsToUEI');

    const fimsIntegrationToggle = this.props.hasOwnProperty('fimsIntegrationToggle')
      ? this.props.fimsIntegrationToggle
      : _.includes(toggles, 'fimsIntegration');
    const vendorSystem = fimsIntegrationToggle ? 'FIMS' : 'IFMIS';

    const chosenVendor = _.find(
      vendors,
      (vendor) => vendor.vendorId === selectedVendorId
    );

    const fullDuns =
      _.get(organization, 'duns') + '' + (_.get(organization, 'dunsPlus4', '') || '');
    const ueiEft =
      _.get(organization, 'uei') +
      (!_.isEmpty(_.trim(_.get(organization, 'eft')))
        ? '-' + _.trim(_.get(organization, 'eft'))
        : '');
    return (
      <React.Fragment>
        <SelectVendorModal
          active={this.state.showVendorList}
          vendors={vendors}
          cancelAction={this.toggleVendorListModal}
          selectAction={this.selectVendor}
          selectedVendor={selectedVendorId}
          vendorSystem={vendorSystem}
        />
        <Header as="h2">Vendor details</Header>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <FemaGoTable
                basic={true}
                columns={4}
                type="entry"
                celled={false}
                summary="Vendor details"
              >
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell arialabel={'no value'} />
                    <FemaGoTable.HeaderCell>Sam.gov</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>{vendorSystem}</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>
                  {dunsToUEIToggle && (
                    <FemaGoTable.Row>
                      <FemaGoTable.TextCell>UEI-EFT</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{ueiEft}</FemaGoTable.TextCell>
                      {numVendorsFound !== 1 ? (
                        <FemaGoTable.TextCell
                          emphasis={numVendorsFound ? 'warning' : 'error'}
                          verticalAlign="middle"
                        >
                          <ErrorIndicator
                            errorType={numVendorsFound === 0 ? 'error' : 'warning'}
                          >
                            {_.get(chosenVendor, 'uei', 'ERROR') != 'ERROR'
                              ? _.get(chosenVendor, 'uei') +
                                (_.get(chosenVendor, 'eftIndicator')
                                  ? '-' + _.get(chosenVendor, 'eftIndicator')
                                  : '')
                              : 'ERROR'}
                          </ErrorIndicator>
                        </FemaGoTable.TextCell>
                      ) : (
                        <FemaGoTable.TextCell>
                          {_.get(chosenVendor, 'uei', 'ERROR') != 'ERROR'
                            ? _.get(chosenVendor, 'uei') +
                              (_.get(chosenVendor, 'eftIndicator')
                                ? '-' + _.get(chosenVendor, 'eftIndicator')
                                : '')
                            : 'ERROR'}
                        </FemaGoTable.TextCell>
                      )}
                    </FemaGoTable.Row>
                  )}
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>DUNS</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{fullDuns}</FemaGoTable.TextCell>
                    {numVendorsFound !== 1 && !dunsToUEIToggle ? (
                      <FemaGoTable.TextCell
                        emphasis={numVendorsFound ? 'warning' : 'error'}
                        verticalAlign="middle"
                      >
                        <ErrorIndicator
                          errorType={numVendorsFound === 0 ? 'error' : 'warning'}
                        >
                          {_.get(chosenVendor, 'duns', 'ERROR')}
                        </ErrorIndicator>
                      </FemaGoTable.TextCell>
                    ) : (
                      <FemaGoTable.TextCell>
                        {_.get(chosenVendor, 'duns', 'ERROR')}
                      </FemaGoTable.TextCell>
                    )}
                  </FemaGoTable.Row>
                  {!dunsToUEIToggle && (
                    <FemaGoTable.Row>
                      <FemaGoTable.TextCell>{`${vendorSystem} vendor ID`}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(chosenVendor, 'vendorId', 'ERROR')}
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  )}
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>{`${vendorSystem} status`}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'ifmisStatus', 'ERROR')}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>{`${vendorSystem} category`}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'vendorCategoryCode', 'ERROR')}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Legal name</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(organization, 'legalBusinessName', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'legalName', 'ERROR')}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Zip code</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(organization, 'mailingAddress.zip', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'zipcode', 'ERROR')}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  {numVendorsFound > 1 && !readOnly && (
                    <FemaGoTable.Row>
                      <FemaGoTable.TextCell />
                      <FemaGoTable.TextCell />
                      <FemaGoTable.TextCell emphasis="warning">
                        {this.selectVendorLink()}
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  )}
                </FemaGoTable.Body>
              </FemaGoTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default connectDynamic(VendorDetails);
